$ = require 'jquery'
Dialog = require 'views/lib/dialog'
Keys = require 'data/keys'
PluginModalView = require 'views/plugin/plugin-modal-view'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'

# Modal
module.exports = PluginModal = new class

  @modalView = null

  shortcut: (key) ->
    switch key
      when Keys.Escape
        @close()
        ["Esc - Hide Plugin Modal", "Plugin Modal"]

  isOpen: -> @modalView?

  open: (args) ->
    { model, content } = args

    PopOver.hide()
    SidebarState.hideUnpinnedSidebar()
    if Dialog.isVisible
      Dialog.hide(true)

    if @modalView?
      @close()

    @modalView = new PluginModalView({ model, content })
    $('.pop-over').before(@modalView.render().el)

    # events

    @modalView.$el.find('a[data-index].plugin-chrome-header-action').click (e) ->
      index = parseInt($(e.currentTarget).attr('data-index'), 10)
      action = content.actions[index]
      action?.callback?({ el: e.currentTarget })
      return

    @modalView.$el.find('.js-close-plugin-chrome').click (e) ->
      Util.stop(e)
      PluginModal.close()
      return

    @modalView.$el.click (e) ->
      if !$(e.target).closest('.plugin-chrome-wrapper').length && !$('.pop-over.is-shown').length
        # clicked outside the modal and no popovers open -> close the modal
        PluginModal.close()
      return

    UserInput.addHandler(@, {
      scope: 'plugin_modal'
      modal: true
    })
    return

  close: ->
    if @modalView?
      @modalView.close()
      @modalView = null

    return



// WEBPACK FOOTER //
// ./app/scripts/views/lib/plugin-modal.coffee